
let aircraftSpruce = "https://aircraftspruce.com" ; 
let aeroLEDs = "https://aeroleds.com/";
let AIM = "https://www.faa.gov/air_traffic/publications/atpubs/aim_html/";
let gulfCoastAvionics = "https://www.gulfcoastavionics.com/"; 
let ASA = "https://asa2fly.com/"; 
let gleim = "https://aviation.gleim.com/";
let jep = "https://jeppesen.com/";
let jep_pp = "https://ww2.jeppesen.com/training-media/";
let oregon = "https://www.oregonaero.com/";






let px =[
    
    {id: 1200, type: 'AircraftSpruce', px_link:  aircraftSpruce},
    {id: 1201, type: 'AeroLEDs', px_link:  aeroLEDs},
    {id: 1202, type: 'GulfCoastAvionics', px_link: gulfCoastAvionics},
    //{id: 1203, type: 'Airmen Information Manual', px_link: AIM},
    {id: 1204, type: 'ASA', px_link: ASA},
    {id: 1205, type: 'Gleim', px_link: gleim},
    {id: 1206, type: 'Jeppesen', px_link: jep},
    //{id: 1207, type: 'Jep_pp', px_link: jep_pp},
    {id: 1208, type: 'Oregon', px_link: oregon},

  
]

export default px;